import React, { useState } from "react";

interface AppImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackSrc?: string;
}

const AppImage: React.FC<AppImageProps> = ({
  src,
  alt = "Image",
  className = "",
  fallbackSrc = "/assets/images/no_image.png",
  ...props
}) => {
  const [imgSrc, setImgSrc] = useState(src);
  const [loading, setLoading] = useState(true);

  const handleError = () => {
    setImgSrc(fallbackSrc);
  };

  const handleLoad = () => {
    setLoading(false);
  };

  return (
    <div className={`relative ${className}`}>
      {loading && (
        <div className="absolute inset-0 bg-gray-200 animate-pulse rounded" />
      )}
      <img
        src={imgSrc}
        alt={alt}
        onError={handleError}
        onLoad={handleLoad}
        className={`w-full h-full object-cover ${
          loading ? "opacity-0" : "opacity-100"
        } transition-opacity`}
        {...props}
      />
    </div>
  );
};

export default AppImage;
